import type { ResourceType } from '../api/types';
import { parsePointer } from './jsonPointer';

/** The injection map's property name, for example `settings` for `/settings`; null if the type has none. */
export function injectionMapName(type: ResourceType | undefined): string | null {
  const segments = parsePointer(type?.injectionProperty ?? '');
  return segments.length === 1 ? segments[0] : null;
}
